/**
 * @desc: - 投注选号 - 全/大/小/奇/偶/清操作
 * @param  {[STRING]} className：   [顶层 class]
 * @param  {[FUNCTION]} onChange:   [变更时候的方法]
 * @param  {[Number]}   methodId:  [彩种ID]
 * @author: ammo
 */
import ReactDOM from 'react-dom';
import FileLoader from '../../../../components/modal/FileLoader.jsx'
import * as Rules from '../../../../constants/lotterys/rules/rulesEntry'
import { SPECIAL_SINGLE } from '../../../../constants/lotterys/singleMethods'

export default class BetInput extends React.Component {

	constructor(props) {
		super(props);
    this.handleDataChange = this.handleDataChange.bind(this);
    this.handleUnique = this.handleUnique.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.openLoadFile = this.openLoadFile.bind(this);
    this.handleFileInput = this.handleFileInput.bind(this);
    this.makeDesc = this.makeDesc.bind(this)
    this.modifiyInputCodes = this.modifiyInputCodes.bind(this);
    this.state = {
      openLoadFileWindow: false
    }
	}


  componentWillReceiveProps(nextProps) {
    if (this.props.methodId != nextProps.methodId) {
      this.handleClear();
    }
  }

  // 去重
  handleUnique(){
    const {bet, category, method} = this.props;
    Rules.execute(category, method, bet, this.modifiyInputCodes, 'ssc');
  }

  modifiyInputCodes(result){
    if (result.message.length > 0) {
      this.props.baseAlert(_.join(result.message, '</br>'));
    }
    ReactDOM.findDOMNode( this.refs.textareaCodes ).value = result.display.codes;
    this.props.onChange(result.display.codes); 
  }

  // 格式校验
  handleDataChange(){
    const {onChange} = this.props;
    let codes = ReactDOM.findDOMNode( this.refs.textareaCodes ).value;
    codes = lotteryService.correctInputData(codes);
    ReactDOM.findDOMNode( this.refs.textareaCodes ).value = codes;
    onChange(codes)
  }

  // 清空
  handleClear(){
    const {onChange} = this.props;
    ReactDOM.findDOMNode( this.refs.textareaCodes ).value = '';
    onChange('');
  }

  // 从文件读取
  handleFileInput(result){
    if (result) {
      ReactDOM.findDOMNode( this.refs.textareaCodes ).value = result; 
      this.handleDataChange();
    }
    this.setState({
      openLoadFileWindow: false
    })
  }

  // 生成说明
  makeDesc(){
    const { methodId } = this.props;
    const singleRule = _.filter(SPECIAL_SINGLE, (item, key) => _.includes(item.methodIds, methodId))[0] || SPECIAL_SINGLE.default;
    return <div className="inputdesc">{singleRule.desc}</div>
  }

  // 打开文件上传窗口
  openLoadFile(){
    this.setState({
      openLoadFileWindow: true
    })
  }

	render() {
		const {className} = this.props;
		return (
			<div className="grayContent clearfix">

              <textarea className="textareaLong fl" onChange={_.debounce(this.handleDataChange, 200)}  ref="textareaCodes" id='bet-input-codearea' />
              <div className="fl">
                <p className="mb5">
                  <input type="button" value="删除重复号" onClick={this.handleUnique} className="formWord" />
                </p>
                <p className="mb5">
                  <input type="button" value="导入文件" onClick={this.openLoadFile} className="formWord" />
                </p>
                <p className="mb5">
                  <input  type="button" value="清空" onClick={this.handleClear} className="formWord" />
                </p>
              </div>
                {
                    this.makeDesc()
                }
        <div className="clearfix"></div>
        {
          this.state.openLoadFileWindow ? 
          <div>
            <div className='overlay-mask'></div>
            <FileLoader 
              display={this.state.openLoadFileWindow}
              suffix={['txt','cvs']} 
              size='1024' 
              callback={this.handleFileInput} 
            />
          </div> : null
        }
      </div>
		);
	}
}
